import { Alert, Button, Input } from '30pay/components';
import { DepositNetwork, NetworksApiResponse, NetworksTypes } from 'interfaces';
import { useEffect, useRef, useState } from 'react';
import { BsChevronDown } from 'react-icons/bs';
import { copyToClipboard, get, post } from 'scripts';
import { Card } from 'utilities/components';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi2';
import { ConvertBoxDataType } from '../../convertBox.index';
import { API } from 'data/30pay.api';
import { __TypeOfOrderEnum } from '../../initial/initial.interface';
import { SelectNetworkModal } from '../../buyWithdrawMethod/modal/selectNetworksModal.index';
import { QRCode } from 'antd';
import { TbCopy } from 'react-icons/tb';
import ConvertBoxConfirmOrderModal from '../../confirmOrderModal/orderDetailModal.index';
import { __ConvertBoxConfirmOrderDetailModalRef } from '../../confirmOrderModal/orderDetailModal.interface';
import { __SellCryptoDepositConvertBoxProps } from './sellCryptoDeposit.interface';
import { DepositAddressModal } from '30pay/components/depositAddressModal/depositAddressModal.index';

const SellCryptoDeposit: React.FC<__SellCryptoDepositConvertBoxProps> = (props: __SellCryptoDepositConvertBoxProps) => {
    const [networksLoading, setNetworksLoading] = useState(true);
    const [networks, setNetworks] = useState<DepositNetwork[]>();
    const [selectedNetwork, setSelectedNetwork] = useState<DepositNetwork>();
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setNetworksLoading(true);
        const isSell = props.data?.typeOfOrder === __TypeOfOrderEnum.sell;
        const targetCoin = isSell ? props.data?.srcCoin?.symbol : props.data?.destCoin?.symbol;
        if (targetCoin) {
            get<{ addressWallets: DepositNetwork[] }>(API.market.depositNetworks(targetCoin.toLowerCase()))
                .then((e) => {
                    const networks = e.value.value.addressWallets;
                    setNetworks(networks);
                    setSelectedNetwork(networks[0]);
                })
                .catch((e) => console.log(e))
                .finally(() => setNetworksLoading(false));
        } else {
            setNetworksLoading(false);
            setNetworks([]);
        }
    }, []);

    function submitHandler() {
        setLoading(true);
        const { data } = props;
        const body = {
            platform: 1,
            network: selectedNetwork?.network,
            symbol: data?.srcCoin?.symbol,
            amount: data?.srcValue,
        };
        post<{ trackingCode: string }>(API.orderTransaction.sellCrypto, body)
            .then((res) => {
                const output: ConvertBoxDataType = {
                    network: selectedNetwork,
                    trackingCode: res.value.value.trackingCode,
                };
                props.onSubmit(output);
                // const body = {
                //     trackingCode: res.value.value.trackingCode,
                //     iBanNumberId: data?.bankAccountId,
                // };
                // post(API.orderTransaction.SetTxId, body)
                //     .then((e) => {
                //         confirmModalRef.current?.showResultContent(true, res.value.value.trackingCode);
                //         props.onFinish();
                //     })
                //     .finally(() => confirmModalRef.current?.stopLoading());
            })
            .catch((e) => console.log(e))
            .finally(() => setLoading(false));
    }

    function backHandler() {
        props.onBack();
    }

    return (
        <div className="flex max-lg:flex-col gap-6 h-full">
            <DepositAddressModal />
            {networks && (
                <SelectNetworkModal
                    isOpen={modalOpen}
                    onClose={() => setModalOpen(false)}
                    networks={networks}
                    onSelect={(network: any) => {
                        setSelectedNetwork(network);
                        setModalOpen(false);
                    }}
                />
            )}
            <Card loading={networksLoading} className="flex-[0.5]" title="روش دریافت" titleDivider>
                <div className="flex flex-col gap-6">
                    <div className="flex flex-col gap-2">
                        <label className={'max-lg:text-sm'}>انتخاب شبکه :</label>
                        <div
                            onClick={() => setModalOpen(true)}
                            className={
                                'flex justify-between items-center border border-primary-40 rounded-[28px] text-base px-6 h-14 max-lg:h-12 max-lg:text-sm mt-2 clickable'
                            }
                        >
                            {!networksLoading &&
                                (selectedNetwork ? (
                                    <>
                                        <div className={'flex items-center gap-4 en'}>{selectedNetwork?.name}</div>
                                        <BsChevronDown />
                                    </>
                                ) : (
                                    <p className="text-sm mx-auto font-medium text-darkPurple-40">
                                        برای انتخاب شبکه مورد نظر کلیک کنید
                                    </p>
                                ))}
                        </div>
                    </div>
                    {/* <div className="gap-2 flex flex-col">
                        <label className="font-bold text-base text-black-100 en text-right">:TXID</label>
                        <Input
                            className={txid && txid !== '' ? 'en' : ''}
                            value={txid}
                            onChange={(e) => setTxid(e.target.value)}
                            placeholder="بعد از واریز به حساب ۳۰ پی TXID را اینجا وارد نمایید "
                        />
                    </div> */}
                </div>
                <div className="flex items-center w-full gap-4 mt-6">
                    <Button
                        loading={loading}
                        disabled={!selectedNetwork}
                        onClick={submitHandler}
                        className="w-full h-16"
                        type="primary"
                    >
                        <HiArrowRight />
                        ادامه
                    </Button>
                    <Button onClick={backHandler} className="w-full h-16 bg-background" type="text">
                        بازگشت
                        <HiArrowLeft />
                    </Button>
                </div>
            </Card>
            {/* <Card className="flex-1">
                <div className="flex gap-4 items-end">
                    {selectedNetwork?.walletAddress && (
                        <QRCode
                            className="min-w-[140px] min-h-[140px]"
                            bordered={false}
                            size={140}
                            value={selectedNetwork?.walletAddress}
                        />
                    )}
                    <div className="flex flex-col gap-2 w-full">
                        <label className="font-bold text-base text-black-100">آدرس کیف پول:</label>
                        <div className="w-full rounded-[28px] border border-primary-20 flex items-center p-2">
                            <p className="w-full flex items-center justify-center font-normal text-base text-black-100">
                                {selectedNetwork?.walletAddress ?? 'داده‌ای موجود نیست'}
                            </p>
                            <Button
                                onClick={() => copyToClipboard(selectedNetwork?.walletAddress, 'آدرس کیف پول')}
                                className="h-8"
                                type="primary"
                            >
                                <div className="flex items-center gap-1 text-white">
                                    <TbCopy />
                                    <span className="text-sm font-bold">کپی</span>
                                </div>
                            </Button>
                        </div>
                    </div>
                </div>
            </Card> */}
        </div>
    );
};
export default SellCryptoDeposit;
